/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export const cellValueToColorsMap = (theme: { [key: string]: string }): { [key: string]: { cellColor: string; textColor: string } } => ({
    '0.0': {
        cellColor: theme.cellColor0,
        textColor: theme.textColor0
    },
    0.2: {
        cellColor: theme.cellColor2,
        textColor: theme.textColor2
    },
    0.4: {
        cellColor: theme.cellColor4,
        textColor: theme.textColor4
    },
    0.6: {
        cellColor: theme.cellColor6,
        textColor: theme.textColor6
    },
    0.8: {
        cellColor: theme.cellColor8,
        textColor: theme.textColor8
    }
});

export const getCellColor = (value: number, theme: { [key: string]: string }) => {
    const colorMap = cellValueToColorsMap(theme);

    if (value < 0.2) {
        return colorMap['0.0'];
    }

    if (value < 0.4) {
        return colorMap['0.2'];
    }

    if (value < 0.6) {
        return colorMap['0.4'];
    }

    if (value < 0.8) {
        return colorMap['0.6'];
    }

    return colorMap['0.8'];
};
